import React, { useState } from 'react'
import { Box, Textfield, SwxTheme } from 'swx-atomic-component-lib'
import _ from 'lodash'
import { parsePhoneNumber } from 'awesome-phonenumber'

import PhoneIcon from 'calcite-ui-icons-react/PhoneIcon'
import i18n from '../../../i18n'

import {
  textFieldStyle,
  commonTextFieldWrapperStyle,
  iconRowStyle,
  formRowStyle,
  iconStyle
} from './style'

function PhoneFormComponent (props) {
  const [phoneError, setPhoneError] = useState(false)
  const phoneDebounced = _.debounce(onPhoneChange, 275)

  const { phoneValue, phoneChange } = props

  // This is for reset
  // useEffect(() => {
  //   if (phoneValue === '' && phoneError) {
  //     setPhoneError(false)
  //   }
  // }, [phoneValue, setPhoneError])

  function onPhoneChange (value, elem) {
    if (value) {
      const awnObj = parsePhoneNumber(_.trim(value), { regionCode: 'AU' })
      setPhoneError(!awnObj.valid)
      phoneChange(value, value === '' || !awnObj.valid)
    } else {
      setPhoneError(false)
      phoneChange(value, false)
    }
  }

  return (
    <Box customStyle={formRowStyle}>
      <Box customStyle={iconRowStyle}>
        <PhoneIcon size={16} color={SwxTheme.palette.primary} style={iconStyle} />
      </Box>
      <Box customStyle={commonTextFieldWrapperStyle} ml={3}>
        <Textfield
          type='text'
          placeholder={i18n.registerNewPage.placeholder.phone}
          customStyle={textFieldStyle}
          round
          defaultValue={phoneValue}
          onChange={phoneDebounced}
          error={phoneError}
          message={phoneError ? i18n.registerNewPage.error.phone : ''}
          color='primary'
          tabIndex='4'
        />
      </Box>
    </Box>
  )
}

export default PhoneFormComponent
